import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import { Location } from '@angular/common';

@Component({
selector:'app-booking-calendar',
templateUrl:'./booking-calendar.component.html',
styleUrls:['./booking-calendar.component.scss']
})
export class BookingCalendarComponent implements OnInit {


serviceId:any;

service:any;

merchantId:any;


today=new Date();


month=this.today.getMonth();

year=this.today.getFullYear();


monthName='';


calendarDays:any[]=[];


blockedDates:any[]=[];

weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

constructor(
private route:ActivatedRoute,
private apiService:ApiServiceService,
private router:Router,
private location: Location
){}



ngOnInit(){


this.serviceId =
this.route.snapshot.paramMap.get('serviceId');


this.getServiceDetails();


}

  goBack(): void {
  this.location.back();
}


getServiceDetails(){


this.apiService
.getServiceDetails(this.serviceId)
.subscribe({

next:(res:any)=>{


this.service=res.data;



this.merchantId =
this.service.merchantId ||
this.service.merchant_id;



this.loadMerchantCalendar();


},

error:(err)=>{

console.log(err);

}


});


}





loadMerchantCalendar(){


this.apiService
.getBlockedDates(this.merchantId)
.subscribe({

next:(res:any)=>{


this.blockedDates=res.data;


this.generateCalendar();


},

error:(err)=>{

console.log(err);

}


});


}







generateCalendar() {

  this.monthName = new Date(
    this.year,
    this.month
  ).toLocaleString('default', {
    month: 'long'
  });

  const totalDays = new Date(
    this.year,
    this.month + 1,
    0
  ).getDate();

  const firstDay = new Date(
    this.year,
    this.month,
    1
  ).getDay();

  this.calendarDays = [];

  // Empty cells before first day
  for (let i = 0; i < firstDay; i++) {
    this.calendarDays.push(null);
  }

  // Actual dates
  for (let i = 1; i <= totalDays; i++) {
    this.calendarDays.push(i);
  }

}







previousMonth(){


if(this.isPreviousMonthDisabled()){

return;

}


this.month--;



if(this.month<0){

this.month=11;

this.year--;

}


this.generateCalendar();


}





nextMonth(){


this.month++;


if(this.month>11){

this.month=0;

this.year++;

}


this.generateCalendar();


}







isPreviousMonthDisabled(){


const currentMonth =
this.today.getMonth();


const currentYear =
this.today.getFullYear();



return (

this.year===currentYear &&

this.month===currentMonth

);


}







isPastDate(day:number){


const selected =
new Date(
this.year,
this.month,
day
);



const today =
new Date();


today.setHours(0,0,0,0);



return selected < today;


}







isBlockedDate(day:number){


return this.blockedDates.some(

(item:any)=>{


const date =
new Date(item.date);



return (

date.getDate()===day &&

date.getMonth()===this.month &&

date.getFullYear()===this.year

);


}

);


}






isDateDisabled(day: any) {

  if (day == null) {
    return false;
  }

  return (
    this.isPastDate(day) ||
    this.isBlockedDate(day)
  );

}







selectDate(day:number){


if(this.isDateDisabled(day)){

return;

}



const selectedDate={


day:day,


month:this.month,


year:this.year


};



console.log(
"SELECTED DATE",
selectedDate
);



sessionStorage.setItem(

'bookingData',

JSON.stringify({

serviceId:this.serviceId,

selectedDate:selectedDate

})

);



this.router.navigate([

'/wedding-services/booking-form'

]);


}



}